//Margin conventions
var margin = {top: 20, right: 15, bottom: 30, left: 35};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .ticks(5)
  .tickFormat(function(d) { return "$" + d/1000000000 + "b" ; })
  .orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .tickPadding(8)
  .orient("bottom")
  .ticks(5)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .x(function(d) { return xScale(d.year); })
  .y(function(d) { return yScale(d.num); }); 

//area function
//var area = d3.svg.area()
//  .x(function(d) {return xScale(d.year); }) 
//  .y0(height)  
//  .y1(function(d) {return yScale(d.num); });    

//Loads the data
d3.csv("data/exim.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.num = +d.num;
    d.year = parseDate(d.year);
  });
  
  //Organizes the data  
  data.sort(function(a,b) { return a.year - b.year; });
  var maxY = d3.max(data, function(d) { return d.num; });
  var maxX = d3.max(data, function(d) { return d.year; });

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.year; }));

  //Defines the yScale max
  yScale.domain([0, 15000000000]);

  //Obama section
  var rectangle = svg.append("rect")
      .attr("x", width/1.86)
      .attr("y", 0)
      .attr("width", width/2.16)
      .attr("height", height)
      .attr("class", "obamaRect");  

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .selectAll("g")
    .classed("g-baseline", function(d) {return d == 0});

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .attr("transform", "translate(0," + height + ")")
    .call(xAxis);   

  //Binds the data to the line
  var drawline = svg.append("path")
    .datum(data)
    .attr("class", "line")
    .attr("d", line);  

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 20, right: 15, bottom: 30, left: 35};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .x(function(d) { return xScale(d.year); })
      .y(function(d) { return yScale(d.num); }); 

    d3.selectAll('.line')
      .attr("d", line); 

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(5);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    rectangle
          .attr("x", newWidth/1.86)
          .attr("width", newWidth/2.16);

  };

}